import { FC } from 'react';

import CommonUtils from 'application/utils/CommonUtils';
import { CURRENCIES_SIGNS } from 'application/pages/constants';

import { Currencies, PricePlanRowPureType } from '@shared/api/graphql/generated';

import PrimeDiscount from '../PrimeDiscount';
import { getSubscriptionPeriod, getText } from './utils';

import styles from './index.module.scss';

interface RatesListProps {
  isPrimeDiscountAvailable: boolean;
  rows: PricePlanRowPureType[];
  primeDiscountValue?: number;
  elementIdPrefix: string;
  pricePlanCurrency: Currencies;
  periodPayFrequencyMonth: number;
}

export const RatesList: FC<RatesListProps> = ({
  isPrimeDiscountAvailable,
  rows,
  primeDiscountValue,
  elementIdPrefix,
  pricePlanCurrency,
  periodPayFrequencyMonth,
}) => (
  <div>
    {isPrimeDiscountAvailable && rows.length > 0 && (
      <PrimeDiscount
        primeDiscountValue={
          primeDiscountValue
        }>{`${CommonUtils.numberWithSeparation(rows[0].amount)} ₽`}</PrimeDiscount>
    )}

    {rows.map((row, index) => (
      <div
        key={row.id}
        className={styles.rowContainer}
        id={`${elementIdPrefix}_${row.id}`}>
        <span className={styles.description}>
          {getText({ row, withPrimeDiscount: isPrimeDiscountAvailable && row.stepRangeLower === 1 })}
        </span>

        <div
          className={styles.price}
          id={`${elementIdPrefix}_tariff_data_${index + 1}`}>
          <span className={styles.semiboldText}>{CommonUtils.numberWithSeparation(row.amount)}</span>
          <span className={styles.semiboldText}> {CURRENCIES_SIGNS[pricePlanCurrency]} </span>
          <span>{getSubscriptionPeriod(periodPayFrequencyMonth)}</span>
        </div>
      </div>
    ))}
  </div>
);
